import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Route } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/route.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';

@Component({
    selector: 'app-line-auto-complete-result',
    templateUrl: './line-auto-complete-result.component.html',
    styleUrls: ['./line-auto-complete-result.component.scss'],
    standalone: false
})
export class LineAutoCompleteResultComponent {
  @Output() onResultClick: EventEmitter<Route> = new EventEmitter<Route>();
  @Output() onAgencyClick = new EventEmitter<number>();

  @Input() line: Route;
  @Input() isPointer = true;

  constructor(
    public readonly routePlanningService: RoutePlanningService
  ) {

  }
}
